import {Button} from '@mui/material';
import {useCan} from 'src/permissions/hooks';
import {FC} from 'react';
import {FormattedMessage} from 'react-intl';
import {contractsApi} from 'src/api';
import {useAppDispatch} from 'src/app/hooks';
import {preloaderChangeStatus} from 'src/stores/common/commonSlice';
import {AppDispatch} from 'src/types';
import {NotifyError} from 'src/utils/notification';
import {moveToOperationButtonSx} from './MoveOperationButton.sx';
import {MoveOperationButtonType} from './MoveOperationButton.types';

type ChangeContractStatusTrigger = ReturnType<
    typeof contractsApi.useToggleContractStatusMutation
>[0];

const handleChangeContractStatus =
    (
        trigger: ChangeContractStatusTrigger,
        dispatch: AppDispatch,
        contractId: number,
        businessId: number
    ) =>
        async () => {
            dispatch(preloaderChangeStatus(true));
            const formData = new FormData();
            formData.set('businessId', String(businessId));
            try {
                await trigger({formData, contractId})
                    .unwrap()
                    .catch((error) => NotifyError(error.data.message));
            } catch (error: any) {
                NotifyError(error.data.message);
            } finally {
                dispatch(preloaderChangeStatus(false));
            }
        };

export const MoveOperationButton: FC<MoveOperationButtonType> = ({contractId, businessId}) => {
    // The control is the action: without the permission the server refuses it, so showing it
    // offers a button whose only outcome is an error.
    const canDoIt = useCan('contracts.activate');
    const [updateStatus] = contractsApi.useToggleContractStatusMutation();
    const dispatch = useAppDispatch();

    if (!canDoIt) {
        return null;
    }

    return (
        <Button
            variant="contained"
            onClick={handleChangeContractStatus(updateStatus, dispatch, contractId, businessId)}
            sx={moveToOperationButtonSx}
        >
            <FormattedMessage id="moveToOperation"/>
        </Button>
    );
};
